// Дзеркало Prisma enum NotificationType. Події сповіщень (D26).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const NotificationType = {
    SCHEDULE_PUBLISHED: 'SCHEDULE_PUBLISHED',
    ENTRY_CHANGED: 'ENTRY_CHANGED',
    ROOM_CHANGED: 'ROOM_CHANGED',
    TEACHER_CHANGED: 'TEACHER_CHANGED',
    ENTRY_MOVED: 'ENTRY_MOVED',
    ENTRY_CANCELLED: 'ENTRY_CANCELLED',
    APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',
    VERSION_RETURNED: 'VERSION_RETURNED',
    VERSION_APPROVED: 'VERSION_APPROVED',
    GENERATION_DONE: 'GENERATION_DONE',
    GENERATION_FAILED: 'GENERATION_FAILED',
    IMPORT_DONE: 'IMPORT_DONE',
};
/** Значення в порядку оголошення в схемі. */
export const NOTIFICATION_TYPE_VALUES = ['SCHEDULE_PUBLISHED', 'ENTRY_CHANGED', 'ROOM_CHANGED', 'TEACHER_CHANGED', 'ENTRY_MOVED', 'ENTRY_CANCELLED', 'APPROVAL_REQUIRED', 'VERSION_RETURNED', 'VERSION_APPROVED', 'GENERATION_DONE', 'GENERATION_FAILED', 'IMPORT_DONE'];
export const NOTIFICATION_TYPE_LABELS = {
    SCHEDULE_PUBLISHED: 'Опубліковано новий розклад',
    ENTRY_CHANGED: 'Зміна заняття',
    ROOM_CHANGED: 'Зміна аудиторії',
    TEACHER_CHANGED: 'Зміна викладача',
    ENTRY_MOVED: 'Перенесення заняття',
    ENTRY_CANCELLED: 'Скасування заняття',
    APPROVAL_REQUIRED: 'Потрібне погодження',
    VERSION_RETURNED: 'Повернуто на доопрацювання',
    VERSION_APPROVED: 'Розклад затверджено',
    GENERATION_DONE: 'Генерацію завершено',
    GENERATION_FAILED: 'Помилка генерації',
    IMPORT_DONE: 'Імпорт завершено',
};
//# sourceMappingURL=notification-type.js.map